// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__CkPoR","select":"Header_select__3bdTu","clinic":"Header_clinic__1w5NW"};